var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIllusEscalier(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 304,
    height: 486,
    viewBox: "0 0 304 486"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "IllusEscalier_svg__a",
    d: "M65 0v364"
  }), /*#__PURE__*/React.createElement("path", {
    id: "IllusEscalier_svg__c",
    d: "M1 0v364"
  }), /*#__PURE__*/React.createElement("path", {
    id: "IllusEscalier_svg__d",
    d: "M1 47h64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "IllusEscalier_svg__f",
    d: "M1 99h64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "IllusEscalier_svg__g",
    d: "M1 151h64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "IllusEscalier_svg__h",
    d: "M1 203h64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "IllusEscalier_svg__i",
    d: "M1 255h64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "IllusEscalier_svg__j",
    d: "M1 307h64"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "IllusEscalier_svg__b",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "IllusEscalier_svg__e",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopOpacity: 0.5
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F7F5F0",
    d: "M62 168v-.009L61 168C27.648 168 .547 141.233.008 108.009L0 107c0-33.69 27.31-61 61-61a60.892 60.892 0 0120.395 3.493C94.557 20.31 123.907 0 158 0c41.54 0 76.036 30.152 82.798 69.763A49.978 49.978 0 01254 68c27.614 0 50 22.386 50 50s-22.386 50-50 50H62z"
  }), /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(190 118)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#D8D8D8",
    xlinkHref: "#IllusEscalier_svg__a"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#IllusEscalier_svg__b)",
    stroke: "#0F1941",
    strokeWidth: 8,
    xlinkHref: "#IllusEscalier_svg__a"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(190 118)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#D8D8D8",
    xlinkHref: "#IllusEscalier_svg__c"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#IllusEscalier_svg__b)",
    stroke: "#0F1941",
    strokeWidth: 8,
    xlinkHref: "#IllusEscalier_svg__c"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(190 118)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#D8D8D8",
    xlinkHref: "#IllusEscalier_svg__d"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#IllusEscalier_svg__e)",
    stroke: "#0F1941",
    strokeWidth: 8,
    xlinkHref: "#IllusEscalier_svg__d"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(190 118)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#D8D8D8",
    xlinkHref: "#IllusEscalier_svg__f"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#IllusEscalier_svg__e)",
    stroke: "#0F1941",
    strokeWidth: 8,
    xlinkHref: "#IllusEscalier_svg__f"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(190 118)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#D8D8D8",
    xlinkHref: "#IllusEscalier_svg__g"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#IllusEscalier_svg__e)",
    stroke: "#0F1941",
    strokeWidth: 8,
    xlinkHref: "#IllusEscalier_svg__g"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(190 118)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#D8D8D8",
    xlinkHref: "#IllusEscalier_svg__h"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#IllusEscalier_svg__e)",
    stroke: "#0F1941",
    strokeWidth: 8,
    xlinkHref: "#IllusEscalier_svg__h"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(190 118)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#D8D8D8",
    xlinkHref: "#IllusEscalier_svg__i"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#IllusEscalier_svg__e)",
    stroke: "#0F1941",
    strokeWidth: 8,
    xlinkHref: "#IllusEscalier_svg__i"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(190 118)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#D8D8D8",
    xlinkHref: "#IllusEscalier_svg__j"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#IllusEscalier_svg__e)",
    stroke: "#0F1941",
    strokeWidth: 8,
    xlinkHref: "#IllusEscalier_svg__j"
  }))))));
}
export default "data:image/svg+xml;base64,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";
export { SvgIllusEscalier as ReactComponent };